import * as Scrivito from "scrivito";

export default function isActiveObj(obj) {
  if (!obj) {
    return false;
  }
  if (Scrivito.isInPlaceEditingActive()) {
    return true;
  }

  const isObjDeactivated = obj.get("isDeactivated");

  if (isObjDeactivated) {
    return false;
  }

  return true;
}
